import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Navigation from 'modules/hc/components/navigation';
import Profile from "modules/hc/profile";
import studentsList from "modules/hc/studentsList";
import Student from "modules/hc/StudentRoutes";
import LcSchedule from "modules/hc/LcSchedule";
import Curriculum from 'modules/hc/curriculum';
import Meeting from "./twilio/VideoChat";
import NotificationPage from "./pages/notification/Page";
import Messages from "./pages/messages";
import Groups from "./groups";
import MeetingView from '../modules/admin/meeting/view'
import TimelineTemplates from '../modules/admin/timeline-templates';
import Home from '../modules/hc/Home';
import TimeTracker from "./pages/time-tracker";
import TODOS from 'modules/admin/todos';
import { HcSidebar } from 'constant';
import Layout from './Layout';
import Engagement from "../modules/admin/engagement";
import Campaigns from "../modules/admin/campaigns/list";
import FileManager from "../modules/file-manager";
import EssayReview from "./pages/essay-review";
import SharePopup from "./social-share/SharePopup";
import Referral from '../modules/referral';

class Hc extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Layout
        navigations={HcSidebar}
        role="head_coach"
        renderHeader={({ toggleMenu }) => (
          <Navigation toggleMenu={toggleMenu} />
        )}
      >
        <SharePopup />
        <Switch>
          <Route exact path="/sessions" component={Home} />
          <Route exact path="/students" component={studentsList} />
          <Route path="/students/:id" component={Student} />
          <Route path="/inbox" component={Messages} />
          <Route
            path="/profile"
            render={(props) => <Profile {...props} sub={this.props.sub} />}
          />
          <Route exact path="/calendar" component={LcSchedule} />
          <Route path="/curriculum" component={Curriculum} />
          <Route path="/timeline-templates" component={TimelineTemplates} />
          <Route path="/groups" component={Groups} />
          <Route exact path={'/meeting/:roomId'} component={Meeting} />
          <Route exact path={'/meeting/:conferenceId/view'} component={MeetingView} />
          <Route
            exact
            path={'/meeting/group/:roomId'}
            component={(props) => <Meeting {...props} isGroup />}
          />
          <Route path="/notifications" component={NotificationPage} />
          <Route path="/time-tracker" component={TimeTracker} />
          <Route path="/todos" component={TODOS} />
          <Route path="/engagement" component={Engagement} />
          <Route path="/campaigns" component={Campaigns} />
          <Route path="/files" component={FileManager} />
          <Route path="/essays" component={EssayReview} />
          <Route path="/referral" component={Referral} />
          <Redirect from="/" to="/todos" />
        </Switch>
      </Layout>
    )
  }
}

export default Hc;
